import React, {Component} from 'react';
import {withTranslation} from "react-i18next";
import DefaultLayout from "../../components/DefaultLayout";
import {Row, Col, notification} from 'antd';
import {Card, List, DatePicker, Picker, LocaleProvider, Checkbox} from 'antd-mobile'
import { createForm } from 'rc-form';
import enUS from 'antd-mobile/lib/locale-provider/en_US';
import moment from 'moment';

import BottomPanel from "../../components/BottomPanel";
import OrderService from "../../apiServices/OrderService";
import UserCarService from "../../apiServices/UserCarService";

const CheckboxItem = Checkbox.CheckboxItem;
const nowTimeStamp = Date.now();
const now = new Date(nowTimeStamp);
const expireContract = [
    {label: '6 Tháng', value: '6'},
    {label: '12 Tháng', value: '12'},
    {label: '15 Tháng', value: '15'},
    {label: '18 Tháng', value: '18'},
    {label: '21 Tháng', value: '21'},
    {label: '24 Tháng', value: '24'},
    {label: '30 Tháng', value: '30'},
];

class OrderAutoBuy extends Component {
    constructor(props){
        super(props);

        const urlParams = new URLSearchParams(window.location.search);
        const object_id = urlParams.get('object_id');

        this.state = {
            height: props.height,
            hasError: false,
            carPurposeSelect: null,
            carCategorySelect: null,
            carBrandSelect: null,
            carProductSelect: null,
            carNumberSeatSelect: null,
            carYearSelect: null,
            carAmount: 0,
            contractValue: 0,
            bs04Fee: 0,
            bs05Fee: 0,
            bs13Fee: 0,
            totalAmount: 0,
            baseFee: 0,
            vatFee: 0,
            insFee: 0,
            objectId: object_id,
            objectType: 'CAR',

            hiddenBtn: false,
            date: now,
            dateStart: now,
            bs04FeeActive: 0,
            bs05FeeActive: 0,
            bs13FeeActive: 0,
            expireContractVal: 12,
        };
    }

    componentDidMount() {
        this.setState({height: window.innerHeight + 'px'});

        if(this.state.objectId){
            UserCarService.detail(this.state.objectId).then(response=>{
                let userCar = response.data;
                let insAmount = parseInt(userCar.insu_amount);
                let contractValue = parseInt(userCar.insu_amount);
                let amount = insAmount * 0.014;
                let bs04Fee = insAmount * 0.002;
                let bs05Fee = insAmount * 0.001;
                let bs13Fee = insAmount * 0.001;
                let vatFee = amount * 0.1;
                let insFee = amount - vatFee;

                this.setState({
                    carPurposeSelect: userCar.car_purpose_id,
                    carCategorySelect: userCar.car_category_id,
                    carBrandSelect: userCar.car_brand_id,
                    carProductSelect: userCar.car_product_id,
                    carNumberSeatSelect: userCar.car_number_seat,
                    carYearSelect: userCar.car_year,
                    carAmount: userCar.car_amount,
                    contractValue: contractValue,
                    bs04Fee: bs04Fee,
                    bs05Fee: bs05Fee,
                    bs13Fee: bs13Fee,
                    totalAmount: amount,
                    baseFee: amount,
                    vatFee: vatFee,
                    insFee: insFee,
                });
            }).catch(function(error){
                console.log(error);
            });
        }else{
            this.props.history.replace('/');
        }
    }

    formSubmit = () => {
        let newDate = moment(new Date(this.state.date).toLocaleString('en')).format('YYYY-MM-DD');
        let orderItem = {
            'total_amount': this.state.totalAmount,
            'ins_fee': this.state.insFee,
            'vat_fee': this.state.vatFee,
            'base_fee': this.state.baseFee,
            'bs04_fee': this.state.bs04FeeActive,
            'bs05_fee': this.state.bs05FeeActive,
            'bs13_fee': this.state.bs13FeeActive,
            'expire_contract': this.state.expireContractVal,
            'value_contract': this.state.contractValue,
            'date_start': newDate,
        };
        OrderService.create({
            'object_id': this.state.objectId,
            'object_type': this.state.objectType,
            'total_amount': this.state.totalAmount,
            'vat_amount': this.state.vatFee,
            'items': orderItem
        }).then(response => {
            orderItem.order_id = response.data.id;
            this.props.history.push('/gia-han-hop-dong-buoc-2?object_id='+this.state.objectId);
        }).catch(error => {
            notification.error({
                message: JSON.stringify(error),
                description: 'Lỗi lưu thông tin',
            });
        });
    };

    expireContractChange = e => {
        let monthSelect = parseInt(e[0]);
        this.setState({expireContractVal: monthSelect});
        let contractValue = this.state.contractValue;
        let insFeeYear = contractValue * 0.014;
        let insFeeMonth = insFeeYear / 12;
        let amount = insFeeMonth * monthSelect;

        let bs04Fee = this.state.bs04FeeActive;
        let bs05Fee = this.state.bs05FeeActive;
        let bs13Fee = this.state.bs13FeeActive;

        let totalAmount = amount + parseInt(bs04Fee) + parseInt(bs05Fee) + parseInt(bs13Fee);
        let vatFee = totalAmount * 0.1;
        let insFee = totalAmount - vatFee;

        this.setState({
            baseFee: amount,
            totalAmount: totalAmount,
            vatFee: vatFee,
            insFee: insFee,
        });
    };

    bs4onChange = e =>{
        if (e.target.checked){
            let amount = parseInt(this.state.totalAmount) + parseInt(this.state.bs04Fee);
            let vatFee = amount * 0.1;
            let insFee = amount - vatFee;
            this.setState({
                totalAmount: amount,
                vatFee: vatFee,
                insFee: insFee,
                bs04FeeActive: parseInt(this.state.bs04Fee),
            });
        }else{
            let amount = parseInt(this.state.totalAmount) - parseInt(this.state.bs04Fee);
            let vatFee = amount * 0.1;
            let insFee = amount - vatFee;
            this.setState({
                totalAmount: amount,
                vatFee: vatFee,
                insFee: insFee,
                bs04FeeActive: 0,
            });
        }
    };

    bs5onChange = e =>{
        if (e.target.checked){
            let amount = parseInt(this.state.totalAmount) + parseInt(this.state.bs05Fee);
            let vatFee = amount * 0.1;
            let insFee = amount - vatFee;
            this.setState({
                totalAmount: amount,
                vatFee: vatFee,
                insFee: insFee,
                bs05FeeActive: parseInt(this.state.bs05Fee),
            });
        }else{
            let amount = parseInt(this.state.totalAmount) - parseInt(this.state.bs05Fee);
            let vatFee = amount * 0.1;
            let insFee = amount - vatFee;
            this.setState({
                totalAmount: amount,
                vatFee: vatFee,
                insFee: insFee,
                bs05FeeActive: 0
            });
        }
    };

    bs13onChange = e =>{
        if (e.target.checked){
            let amount = parseInt(this.state.totalAmount) + parseInt(this.state.bs13Fee);
            let vatFee = amount * 0.1;
            let insFee = amount - vatFee;
            this.setState({
                totalAmount: amount,
                vatFee: vatFee,
                insFee: insFee,
                bs13FeeActive: parseInt(this.state.bs13Fee),
            });
        }else{
            let amount = parseInt(this.state.totalAmount) - parseInt(this.state.bs13Fee);
            let vatFee = amount * 0.1;
            let insFee = amount - vatFee;
            this.setState({
                totalAmount: amount,
                vatFee: vatFee,
                insFee: insFee,
                bs13FeeActive: 0,
            });
        }
    };

    render() {
        const { getFieldProps } = this.props.form;
        const vatExtra = (<div><List.Item.Brief>{Number(this.state.insFee).toLocaleString('en')+' đ'}</List.Item.Brief>
            <List.Item.Brief>{Number(this.state.vatFee).toLocaleString('en')+' đ'}</List.Item.Brief></div>);

        return (
            <div className='App-block bgWhite' style={{minHeight: this.state.height}}>
                <DefaultLayout {...this.props} showHome={true} title="Gia hạn hợp đồng" classNameContent="bgWhite" page_type={1} hiddenFt={true} showBottomPanel={true}>
                    <div className="wrap-content">
                        <Card className='autoBuyCard'>
                            <Card.Header
                                title="Bảo hiểm vật chất xe"
                                extra={<span style={{fontWeight: 'bold'}}>{Number(this.state.totalAmount).toLocaleString('en')} đ</span>}
                            />
                            <Row gutter={24} style={{margin: 0}}>
                                <Col span={12} style={{padding: '0'}}>
                                    <Picker extra='Chọn' data={expireContract} cols={1} {...getFieldProps('expireContract', {
                                        initialValue: ['12'],
                                    })}
                                            onOk={this.expireContractChange}
                                            okText="OK"
                                            dismissText="Hủy"
                                            title="Chọn thời hạn"
                                    >
                                        <List.Item wrap arrow="horizontal">Hiệu lực: </List.Item>
                                    </Picker>
                                </Col>
                                <Col span={12} style={{textAlign: 'right', padding: 0}}>
                                    <LocaleProvider locale={enUS}>
                                        <DatePicker mode="date" minDate={now} title="Chọn ngày" extra="Chọn"
                                                    value={this.state.date}
                                                    onChange={date => this.setState({ date })}
                                                    okText="OK"
                                                    dismissText="Hủy"
                                                    format="YYYY-MM-DD"
                                        >
                                            <List.Item wrap arrow="horizontal">Từ ngày: </List.Item>
                                        </DatePicker>
                                    </LocaleProvider>
                                </Col>
                            </Row>

                            <List className="insuPriceList">
                                <CheckboxItem wrap key={1} checked={true} extra={Number(this.state.baseFee).toLocaleString('en')+' đ'}>Phí cơ bản</CheckboxItem>
                                <CheckboxItem wrap key={2} checked={true} extra={'Miễn phí'}>BS02 BH thay thế mới</CheckboxItem>
                                <CheckboxItem onChange={this.bs4onChange} wrap key={3} extra={Number(this.state.bs04Fee).toLocaleString('en')+' đ'}>BS04 BH Xe bị mất trộm, cướp bộ phận</CheckboxItem>
                                <CheckboxItem onChange={this.bs5onChange} wrap key={4} extra={Number(this.state.bs05Fee).toLocaleString('en')+' đ'}>BS05 Lựa chọn cơ sở sửa chữa</CheckboxItem>
                                <CheckboxItem wrap key={5} checked={true} extra={'Miễn phí'}>BS06 BH động cơ do thủy kích</CheckboxItem>
                                <CheckboxItem onChange={this.bs13onChange} wrap key={6} extra={Number(this.state.bs13Fee).toLocaleString('en')+' đ'}>BS13 BH thiết bị lắp thêm</CheckboxItem>
                            </List>

                            <List className={'insuBottomList'}>
                                <List.Item multipleLine extra={vatExtra}>
                                    Phí bảo hiểm
                                    <List.Item.Brief>Thuế VAT</List.Item.Brief>
                                </List.Item>
                                <List.Item className={'totalAmount'} extra={Number(this.state.totalAmount).toLocaleString('en')+' đ'}>Tổng phí bảo hiểm</List.Item>
                            </List>
                        </Card>

                    </div>
                </DefaultLayout>
                <BottomPanel handleClick={this.formSubmit} hidden={this.state.hiddenBtn} title={"Tiếp tục"} actionType='submit' actionContent={'thong-tin-nguoi-mua'}/>
            </div>
        )
    }
}

OrderAutoBuy = createForm()(OrderAutoBuy);

export default (withTranslation())(OrderAutoBuy);